<template>
    <div class="restaurant-commands-page">
        <div class="page-header pr-0">
            <h2>
                <i class="fas fa-receipt"></i>
                Restaurante V2
                <span>/ Comandas</span>
            </h2>
        </div>

        <div class="card mb-0">
            <div class="card-header bg-info">
                <h3 class="my-0">Comandas de cocina / barra</h3>
            </div>

            <div class="card-body">
                <div class="row mb-3">
                    <div class="col-md-4">
                        <label>Estado</label>
                        <el-select v-model="filters.status" clearable placeholder="Todos">
                            <el-option label="Pendiente" value="sent"></el-option>
                            <el-option label="Preparado" value="ready"></el-option>
                        </el-select>
                    </div>

                    <div class="col-md-4">
                        <label>Área</label>
                        <el-select v-model="filters.area" clearable placeholder="Todas">
                            <el-option
                                v-for="area in areas"
                                :key="area.id"
                                :label="area.name"
                                :value="area.name">
                            </el-option>
                        </el-select>
                    </div>

                    <div class="col-md-4 d-flex align-items-end">
                        <button class="btn btn-primary btn-block" @click="getRecords">
                            <i class="fas fa-sync-alt"></i>
                            Actualizar
                        </button>
                    </div>
                </div>

                <div v-if="filteredRecords.length === 0" class="restaurant-empty">
                    <i class="fas fa-check-circle"></i>
                    <h4>No hay comandas pendientes</h4>
                    <p>Cuando el mozo imprima una comanda, aparecerá aquí.</p>
                </div>

                <div class="restaurant-command-grid">
                    <div
                        class="restaurant-command-card"
                        v-for="ticket in filteredRecords"
                        :key="ticket.id"
                        :class="{ ready: ticket.status === 'ready' }">

                        <div class="restaurant-command-head">
                            <div>
                                <h4>{{ ticket.area || 'Sin área' }}</h4>
                                <p>
                                    Pedido #{{ ticket.order.id }}
                                    <span v-if="ticket.order.room"> | {{ ticket.order.room }}</span>
                                    <span v-if="ticket.order.table"> - Mesa {{ ticket.order.table }}</span>
                                </p>
                            </div>

                            <span class="badge" :class="ticket.status === 'ready' ? 'badge-success' : 'badge-warning'">
                                {{ ticket.status_label }}
                            </span>
                        </div>

                        <div class="restaurant-command-time">
                            <i class="far fa-clock"></i>
                            {{ ticket.sent_at }}
                        </div>

                        <div class="restaurant-command-items">
                            <div class="restaurant-command-item" v-for="item in ticket.items" :key="item.id">
                                <strong>{{ Number(item.quantity).toFixed(0) }} x</strong>
                                <div>
                                    <h5>{{ item.description }}</h5>
                                    <p v-if="item.note">{{ item.note }}</p>
                                </div>
                            </div>
                        </div>

                        <button
                            v-if="ticket.status === 'sent'"
                            class="btn btn-success btn-block"
                            @click="markReady(ticket)">
                            <i class="fas fa-check"></i>
                            Marcar preparado
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            resource: 'restaurant/v2/commands',
            records: [],
            areas: [],
            filters: {
                status: null,
                area: null,
            },
        }
    },
    computed: {
        filteredRecords() {
            return this.records.filter(row => {
                if (this.filters.status && row.status !== this.filters.status) {
                    return false
                }

                if (this.filters.area && row.area !== this.filters.area) {
                    return false
                }

                return true
            })
        },
    },
    created() {
        this.getTables()
        this.getRecords()
    },
    methods: {
        getTables() {
            this.$http.get(`/${this.resource}/tables`).then(response => {
                this.areas = response.data.areas || []
            })
        },
        getRecords() {
            this.$http.get(`/${this.resource}/records`).then(response => {
                this.records = response.data.data || []
            })
        },
        markReady(ticket) {
            this.$http.post(`/${this.resource}/${ticket.id}/ready`).then(response => {
                if (response.data.success) {
                    this.$message.success(response.data.message)
                    this.getRecords()
                } else {
                    this.$message.warning(response.data.message)
                }
            })
        },
    },
}
</script>

<style scoped>
.restaurant-commands-page {
    padding: 0 15px 15px;
}

.restaurant-command-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 16px;
}

.restaurant-command-card {
    background: #fff;
    border: 1px solid #e5e9f2;
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
}

.restaurant-command-card.ready {
    opacity: .75;
}

.restaurant-command-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    border-bottom: 1px solid #edf0f5;
    padding-bottom: 10px;
    margin-bottom: 10px;
}

.restaurant-command-head h4 {
    margin: 0;
    color: #1f2937;
    font-size: 18px;
    font-weight: 700;
}

.restaurant-command-head p {
    margin: 4px 0 0;
    color: #697386;
    font-size: 13px;
}

.restaurant-command-time {
    color: #697386;
    font-size: 13px;
    margin-bottom: 12px;
}

.restaurant-command-items {
    min-height: 120px;
    margin-bottom: 14px;
}

.restaurant-command-item {
    display: grid;
    grid-template-columns: 52px 1fr;
    gap: 10px;
    padding: 10px 0;
    border-bottom: 1px solid #edf0f5;
}

.restaurant-command-item strong {
    color: #00a99d;
    font-size: 18px;
}

.restaurant-command-item h5 {
    margin: 0;
    color: #111827;
    font-size: 15px;
    font-weight: 700;
}

.restaurant-command-item p {
    margin: 4px 0 0;
    color: #d97706;
    font-size: 13px;
}

.restaurant-empty {
    background: #f8fafc;
    border: 1px dashed #d6dde6;
    border-radius: 8px;
    padding: 40px 20px;
    text-align: center;
    color: #697386;
}

.restaurant-empty i {
    color: #00a99d;
    font-size: 42px;
    margin-bottom: 12px;
}

.restaurant-empty h4 {
    color: #1f2937;
    font-weight: 700;
}
</style>


// WEBPACK FOOTER //
// modules/Restaurant/Resources/assets/js/views/v2/commands/index.vue